import { FunctionComponent, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { PrimaryButton } from "../../../components/button";
import { colours } from "../../../styles/colours";

const background = "#1b2032";

export interface IFooterProps {}

const FooterWrapper = styled.footer`
  background: ${background};
  color: ${colours.white};
  padding: 3em;
  display: grid;
  gap: 1em;
  font-size: 1.3em;
  font-weight: 400;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
`;

const Title = styled.h3`
  font-family: "Patua One", sans-serif;
  text-transform: uppercase;
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  padding: 0.3em 0;
`;

const Link = styled.a`
  color: inherit;
`;

const useData = () => {
  const { t } = useTranslation("common");
  return useMemo(
    () => [
      {
        title: t("about-us"),
        links: [
          {
            title: t("company"),
            url: "https://sekuritance.com/about-us/company",
          },
          { title: t("team"), url: "https://sekuritance.com/about-us/team" },
          {
            title: t("partners"),
            url: "https://sekuritance.com/about-us/partners",
          },
          { title: t("blog"), url: "https://sekuritance.com/blog" },
          {
            title: t("skrt-token"),
            url: "https://sekuritance.com/about-us/skrt-token",
          },
          {
            title: t("careers"),
            url: "https://sekuritance.com/about-us/careers",
          },
          {
            title: t("media-kit"),
            url: "https://sekuritance.com/about-us/media-kit",
          },
          { title: t("faqs"), url: "https://sekuritance.com/about-us/faqs" },
        ],
      },
      {
        title: "Sekur.Suite",
        links: [
          {
            title: "Sekur.Transact",
            url: "https://sekuritance.com/sekur-suite/sekur-transact",
          },
          {
            title: "Sekur.Trace",
            url: "https://sekuritance.com/sekur-suite/sekur-trace",
          },
          {
            title: "Sekur.Vault",
            url: "https://sekuritance.com/sekur-suite/sekur-vault",
          },
          {
            title: "Sekur.Auth",
            url: "https://sekuritance.com/sekur-suite/sekur-auth",
          },
          {
            title: "Sekur.Alert",
            url: "https://sekuritance.com/sekur-suite/sekur-alert",
          },
          {
            title: "Sekur.Certify",
            url: "https://sekuritance.com/sekur-suite/sekur-certify",
          },
        ],
      },
    ],
    [t]
  );
};

export const Footer: FunctionComponent<IFooterProps> = () => {
  const data = useData();
  const { t } = useTranslation("common");
  return (
    <FooterWrapper>
      {data.map(({ title, links }) => (
        <div key={title}>
          <Title>{title}</Title>
          <List>
            {links.map(({ title, url }) => (
              <ListItem key={url}>
                <Link href={url}>{title}</Link>
              </ListItem>
            ))}
          </List>
        </div>
      ))}
      <div>
        <Title>{t("whitepaper")}</Title>
        <p>{t("in-this-paper-we-introduce")}</p>
        <PrimaryButton variant="text" icon="export">
          {t("download")}
        </PrimaryButton>
      </div>
      <div>
        <Title>{t("get-support")}</Title>
        <p>+353 76 680 3782</p>
        <p>info@sekuritance.com</p>
      </div>
      <div>
        <Title>{t("find-us")}</Title>
        <p>
          77, Lower Camden Street,
          <br /> St Kevin’s Dublin 2<br /> Ireland D 02 XE 80
        </p>
      </div>
    </FooterWrapper>
  );
};
